import createHistory from 'history/createBrowserHistory';
import { applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';

import analyticsMiddleware from './analytics';

export const sagaMiddleware = createSagaMiddleware();
export const history = createHistory();

export default applyMiddleware(
  sagaMiddleware,
  routerMiddleware(history),
  analyticsMiddleware,
);



// WEBPACK FOOTER //
// ./redux/enhancers/middlewares.js